/** Mieterportal 2.0 – Cockpit-Daten, Portal-Einstellungen, Preisspanne, Packliste, Mehrfachaktionen. */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, rufe } from "../api/client";
import type { cockpit } from "../../worker/data/cockpit";
import type { PortalEinstellungen } from "@shared/schemas/mieterportal";

export type Cockpit = Awaited<ReturnType<typeof cockpit>>;
export type Preisspanne = { anzahl: number; minCent: number; medianCent: number; maxCent: number } | null;

export const useCockpit = () => useQuery({ queryKey: ["mieter", "cockpit"], queryFn: () => rufe<Cockpit>(api.api.mieter.cockpit.$get()), staleTime: 15_000 });
export const usePreisspanne = (kategorie: string, wort: string) =>
  useQuery({
    queryKey: ["mieter", "preisspanne", kategorie.trim().toLowerCase(), wort.trim().toLowerCase().split(/[\s,]+/).find((x) => x.length >= 4) ?? ""],
    queryFn: () => rufe<{ spanne: Preisspanne }>(api.api.mieter.erfassen.preisspanne.$get({ query: { kategorie, wort } })),
    enabled: kategorie.trim().length > 0 || wort.trim().length >= 4,
    staleTime: 60_000,
  });

function nach() {
  const qc = useQueryClient();
  return () => void qc.invalidateQueries({ queryKey: ["mieter"] });
}
export function usePortalSpeichern() {
  const n = nach();
  return useMutation({ mutationFn: (e: PortalEinstellungen) => rufe(api.api.mieter.portal.$put({ json: e })), onSuccess: n });
}
export function useEingeraeumt() {
  const n = nach();
  return useMutation({ mutationFn: (artikelIds: string[]) => rufe<{ gemeldet: number }>(api.api.mieter.artikel.eingeraeumt.$post({ json: { artikelIds } })), onSuccess: n });
}
export function useStatusMehrere() {
  const n = nach();
  return useMutation({ mutationFn: (v: { artikelIds: string[]; status: "abgeholt" | "entfernt" | "im_regal" }) => rufe<{ geaendert: number }>(api.api.mieter.artikel["status-mehrere"].$post({ json: v })), onSuccess: n });
}

/** Teilen-Menü des Handys, sonst Zwischenablage. */
export async function teilen(d: { titel: string; text: string; url?: string }): Promise<"geteilt" | "kopiert" | "nein"> {
  try {
    if (navigator.share) {
      await navigator.share({ title: d.titel, text: d.text, url: d.url });
      return "geteilt";
    }
    await navigator.clipboard.writeText(`${d.text}${d.url ? ` ${d.url}` : ""}`);
    return "kopiert";
  } catch {
    return "nein";
  }
}
